export default __webpack_public_path__ + "static/construction-banner-29a32ad5d55364606510606c8690281f.webp";